function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobCostingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M30.13,34.85H11.41A4.92,4.92,0,0,1,6.5,29.93V11.22A4.92,4.92,0,0,1,11.41,6.3H30.13A4.92,4.92,0,0,1,35,11.22V29.93A4.92,4.92,0,0,1,30.13,34.85ZM11.41,8.48a2.74,2.74,0,0,0-2.74,2.74V29.93a2.74,2.74,0,0,0,2.74,2.74H30.13a2.74,2.74,0,0,0,2.73-2.74V11.22a2.74,2.74,0,0,0-2.73-2.74Z",
    style: {
      fill: "#62a3ef",
      stroke: "#62a3ef",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.36 25.99 10.71 24.57 16.18 18.16 22.19 22.71 28.52 14.28 30.26 15.58 22.62 25.77 16.51 21.14 12.36 25.99",
    style: {
      fill: "#62a3ef",
      stroke: "#62a3ef",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobCostingIcon);
export default __webpack_public_path__ + "static/media/job_costing_icon.9dd862b2e16047b73cc88847f3a1fc20.svg";
export { ForwardRef as ReactComponent };